var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,47a1,1,0,0,1,0-2,5,5,0,0,0,5-5V25H34a1,1,0,0,1,0-2H46a1,1,0,0,1,1,1V40A7,7,0,0,1,40,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,47H8a7,7,0,0,1-7-7V8A7,7,0,0,1,8,1H28a7,7,0,0,1,7,7V40a5,5,0,0,0,5,5,1,1,0,0,1,0,2ZM8,3A5,5,0,0,0,3,8V40a5,5,0,0,0,5,5H35.11A7,7,0,0,1,33,40V8a5,5,0,0,0-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,20.19a6.86,6.86,0,0,1-1.18-.27,8.07,8.07,0,0,1-.81-.33l.52-1.38a5.7,5.7,0,0,0,1,.37,4.16,4.16,0,0,0,1.23.17,1.72,1.72,0,0,0,1-.2A.63.63,0,0,0,19,18a.6.6,0,0,0-.11-.39,1,1,0,0,0-.31-.3,3.42,3.42,0,0,0-.51-.26l-.72-.27c-.27-.09-.53-.2-.78-.31a3.14,3.14,0,0,1-.68-.43,1.75,1.75,0,0,1-.49-.62,1.84,1.84,0,0,1-.19-.88,2.74,2.74,0,0,1,.11-.76,2.07,2.07,0,0,1,.36-.67,2.09,2.09,0,0,1,.62-.51c.26-.14.56-.24.67-.3V11h2v1.25c.17,0,.53.1.83.18a4.44,4.44,0,0,1,.71.24l-.37,1.44a5.56,5.56,0,0,0-.92-.29,4.79,4.79,0,0,0-1.09-.12,1.37,1.37,0,0,0-.83.19.61.61,0,0,0-.25.51.72.72,0,0,0,.07.33.82.82,0,0,0,.25.24,3.09,3.09,0,0,0,.41.21l.6.23a6.72,6.72,0,0,1,1,.42,3.42,3.42,0,0,1,.78.52,1.94,1.94,0,0,1,.51.69,2,2,0,0,1,.19.92,2.57,2.57,0,0,1-.11.72,1.82,1.82,0,0,1-.36.65,2.23,2.23,0,0,1-.65.51c-.27.15-.6.25-.75.32V22H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,33H11a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,39H11a1,1,0,0,1,0-2H25a1,1,0,0,1,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.7a9b0172235e5397e8e86a9db5379e84.svg";
export { ForwardRef as ReactComponent };